/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
export const FETCH_GLOBAL_ADMIN_FLEX_METADATA_REQUEST =
  "FETCH_GLOBAL_ADMIN_FLEX_METADATA_REQUEST";
export const FETCH_GLOBAL_ADMIN_FLEX_METADATA_SUCCESS =
  "FETCH_GLOBAL_ADMIN_FLEX_METADATA_SUCCESS";
export const FETCH_GLOBAL_ADMIN_FLEX_METADATA_FAILURE =
  "FETCH_GLOBAL_ADMIN_FLEX_METADATA_FAILURE";

// Save filtered chip list in reducer
export const SET_GLOBAL_FLEX_METADATA_CHIP_LIST =
  "SET_GLOBAL_FLEX_METADATA_CHIP_LIST";

export const SET_SUBMISSION_API_DATA = "SET_SUBMISSION_API_DATA";
export const SET_SUBMISSION_FLEX_METADATA_IDS =
  "SET_SUBMISSION_FLEX_METADATA_IDS";
